import { render, staticRenderFns } from "./SwitchAccount.vue?vue&type=template&id=8f39b476&scoped=true"
import script from "./SwitchAccount.vue?vue&type=script&lang=js"
export * from "./SwitchAccount.vue?vue&type=script&lang=js"
import style0 from "./SwitchAccount.vue?vue&type=style&index=0&id=8f39b476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f39b476",
  null
  
)

export default component.exports